cc.SpriteWithHue = cc.Sprite.extend({
    _fromHue: 0,
    _toHue: 0,
    _Fac: 1,
    _FacB : 1,
    _FacS : 1,
    _HError : 0.2,
    
    ctor: function (fileName, rect, rotated) {
        cc.Sprite.prototype.ctor.call(this, fileName, rect, rotated);
        this.initShader();
    },
    initShader: function () {
        var glprogram = cc.shaderCache.programForKey("hue_program");
        if (!glprogram) {
            var glprogram = new cc.GLProgram();
            if (this._texture && this._texture.getPixelFormat() == cc.Texture2D.PIXEL_FORMAT_ETC1){
                glprogram.initWithVertexShaderByteArray(cc.SHADER_POSITION_ETC1_TEXTURE_VERT, this.shaderBodyEtc1());
            }else{
                glprogram.initWithVertexShaderByteArray(cc.SHADER_SPRITE_POSITION_TEXTURE_COLOR_VERT, this.shaderBody());
            }
            glprogram.addAttribute(cc.ATTRIBUTE_NAME_POSITION, cc.VERTEX_ATTRIB_POSITION);
            glprogram.addAttribute(cc.ATTRIBUTE_NAME_TEX_COORD, cc.VERTEX_ATTRIB_TEX_COORDS);
            glprogram.addAttribute(cc.ATTRIBUTE_NAME_COLOR, cc.VERTEX_ATTRIB_COLOR);
            //glprogram = cc.shaderCache.getInstance().createWithByteArrays(cc.SHADER_SPRITE_POSITION_COLOR_VERT , this.shaderBody()); // cc.ccPositionTextureColor_noMVP_vert
            //cc.shaderCache.addProgram(glprogram, "hue_program");
            glprogram.link();
            glprogram.updateUniforms();
            //var _glprogramstate = cc.GLProgramState.getOrCreateWithGLProgram(glprogram);
            //var lala = glprogram._glContext.getProgramParameter( glprogram._programObj,glprogram._glContext.ACTIVE_UNIFORMS);
            //this.setGLProgramState(_glprogramstate);
            // cache locaction
            glprogram._addUniformLocation('_From')
            glprogram._addUniformLocation('_To')
            glprogram._addUniformLocation('_Fac')
            glprogram._addUniformLocation('_FacB')
            glprogram._addUniformLocation('_FacS')
            glprogram._addUniformLocation('_HError')
        }
        this.shaderProgram = glprogram;
        this.updateUniforms();
    },
    shaderBodyEtc1: function () {
        let precision = __NEED_HIGHP_FOR_HUE ? 'highp' : 'lowp'
        return `
            precision ${precision} float;

            varying vec4 v_fragmentColor;
            varying vec2 v_texCoord;
            varying vec2 v_alphaCoord;

            uniform sampler2D _MainTex;
            uniform float _From;
            uniform float _To;
            uniform float _Fac;
            uniform float _FacB;
            uniform float _FacS;
            uniform float _HError; // threshold;  HSV
            // float _SError = 0.8; 
            // float _VError = 0.8;
            vec3 RGBtoHSV(vec3 c)
            {
                vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
                vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
                vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));
                float d = q.x - min(q.w, q.y);
                float e = 1.0e-10;
                return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
            }
            vec3 HSVtoRGB(vec3 c){
                vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
                vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
                vec3 p3 = mix(vec3(0.94,0.3,0.0), vec3(0.1,0.4,0.8),0.1);
                return c.z * mix(K.xxx, clamp(p - K.xxx,0.0,1.0), c.y);
            }

            void main()
            {
                //vec4 c = v_fragmentColor * texture2D(CC_Texture0, v_texCoord);
                vec4 texColor = texture2D(CC_Texture0, v_texCoord);
                texColor.a = texture2D(CC_Texture0, v_alphaCoord).r;
                texColor.rgb = texColor.rgb * texColor.a;
                vec4 c = texColor * v_fragmentColor;

                vec3 cHSV = RGBtoHSV(c.rgb);
                float diffHue = abs(cHSV.x-_From);
                float diffHue2 = mix(diffHue,abs(diffHue-1.0),step(0.5,diffHue));
                
                float con = step(diffHue2,_HError);
                // con = con + step(abs(cHSV.y-FromHSV.y),_SError);
                // con = con + step(abs(cHSV.z-FromHSV.z),_VError);
                con = step(0.5,con);
                vec3 ret = vec3( _To + (cHSV.x - _From)*_Fac,cHSV.y*_FacS,cHSV.z*_FacB); //cHSV + ToHSV - FromHSV;
                vec3 m2 =   mix(c.rgb,HSVtoRGB(ret),vec3(con,con,con));
                gl_FragColor = vec4(m2, c.a);
            }
            `
        // vec3 rgbColor = u_hue * m2;
        // o.Albedo = mix(c.rgb,HSVtoRGB(ret),vec3(con,con,con));
        // o.Alpha = c.a;
        // vec3 rgbColor = u_hue * m2;
    },
    shaderBody: function () {
        let precision = __NEED_HIGHP_FOR_HUE ? 'highp' : 'lowp'
        return `
            precision ${precision} float;

            varying vec4 v_fragmentColor;
            varying vec2 v_texCoord;

            uniform sampler2D _MainTex;
            uniform float _From;
            uniform float _To;
            uniform float _Fac;
            uniform float _FacB;
            uniform float _FacS;
            uniform float _HError; // threshold;  HSV
            vec3 RGBtoHSV(vec3 c)
            {
                vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
                vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
                vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));
                float d = q.x - min(q.w, q.y);
                float e = 1.0e-10;
                return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
            }
            vec3 HSVtoRGB(vec3 c){
                vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
                vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
                vec3 p3 = mix(vec3(0.94,0.3,0.0), vec3(0.1,0.4,0.8),0.1);
                return c.z * mix(K.xxx, clamp(p - K.xxx,0.0,1.0), c.y);
            }

            void main()
            {
                vec4 c = v_fragmentColor * texture2D(CC_Texture0, v_texCoord);

                vec3 cHSV = RGBtoHSV(c.rgb);
                float diffHue = abs(cHSV.x-_From);
                float diffHue2 = mix(diffHue,abs(diffHue-1.0),step(0.5,diffHue));
                
                float con = step(diffHue2,_HError);
                con = step(0.5,con);
                vec3 ret = vec3( _To + (cHSV.x - _From)*_Fac,cHSV.y*_FacS,cHSV.z*_FacB); //cHSV + ToHSV - FromHSV;
                vec3 m2 =   mix(c.rgb,HSVtoRGB(ret),vec3(con,con,con));
                gl_FragColor = vec4(m2, c.a);
            }
            `
    },
    updateUniforms: function () {
        //this.shaderProgram.link();
        //this.shaderProgram.updateUniforms();
        this.shaderProgram.use();
        this.shaderProgram.setUniformLocationWith1f(this.shaderProgram.getUniformLocationForName('_From'), this._fromHue);
        this.shaderProgram.setUniformLocationWith1f(this.shaderProgram.getUniformLocationForName('_To'), this._toHue);
        this.shaderProgram.setUniformLocationWith1f(this.shaderProgram.getUniformLocationForName('_Fac'), this._Fac);
        this.shaderProgram.setUniformLocationWith1f(this.shaderProgram.getUniformLocationForName('_FacB'),  this._FacB );
        this.shaderProgram.setUniformLocationWith1f(this.shaderProgram.getUniformLocationForName('_FacS'),  this._FacS );
        this.shaderProgram.setUniformLocationWith1f(this.shaderProgram.getUniformLocationForName('_HError'),  this._HError );
    },
    setRangeRate: function(rate)
    {
        this._HError =  rate;
        this.updateUniforms();
    },    
    setHue: function (fromhue, tohue, fac = 1, facb = 1, facs = 1) {
        this._fromHue = fromhue;
        this._toHue = tohue;
        this._Fac = fac;
        this._FacB = facb;
        this._FacS = facs;
        this.updateUniforms();
    }
});

cc.SpriteWithHue.create = cc.SpriteWithHue.createFromFile = function (fileName, rect, rotated) {
    if (fileName && fileName[0] !== '#') {
        let frame = cc.spriteFrameCache.getSpriteFrame(fileName)
        if (frame) {
            fileName = frame
        }
    }
    return new cc.SpriteWithHue(fileName, rect, rotated)
}

// var alien = cc.SpriteWithHue.create("alien.png");
// alien.setPosition(Vec2(100, 100));
// alien.setHue(M_PI);
// s = cc.SpriteWithHue.createFrom("a1.png");s.setOpacity(255);cc.Director.getInstance()._runningScene.addChild(s); s.setPosition({x:200,y:300});s.setHue(2);
// s = cc.SpriteWithHue.createFrom("a.png");cc.Director.getInstance()._runningScene.addChild(s); s.setPosition({x:200,y:300});
// s = cc.SpriteWithHue.createFrom("homeConfigRes/building1.png");cc.Director.getInstance()._runningScene.addChild(s); s.setPosition({x:350,y:300});s.rotate(90);
// s = cc.SpriteWithHue.createFrom("a.png");cc.Director.getInstance()._runningScene.addChild(s); s.setPosition({x:350,y:300});s.rotate(-90);
// s.setOpacity(255);s.setHue(1);
// s.setColor(new cc.Color(155,155,155));